<template lang="html">
  <div id="bolsa-trabajo-page">

    <section class="container oversized-container main-section">
      <div class="row">
        <div class="col-12">
          <div class="col-s-title">
            <h2 class="title">Bolsa de trabajo</h2>
          </div>
        </div>

        <div class="col-12 col-lg-6 col-job" v-for="(blog, index) in rows" :key="index">
          <router-link class="box-link-job" :to="'/bolsa-de-trabajo/'+blog.id">
            <h5 class="job-name">{{ blog.title }}</h5>
            <div class="box-descr" v-html="blog.body"></div>
            <h6 class="date">{{ blog.date }}</h6>
            <!-- <div class="note">Urgente</div>
            <h5 class="job-name">Ejemplo de empleo en línea</h5>
            <h6 class="job-salary">$12,000.00</h6> -->
          </router-link>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
export default {
  data(){
    return{
      rows: [],
    }
  },

  methods: {
    getDAta: function(){
      axios.get(tools.url('/api/bolsatrabajo/'+this.$route.params.id)).then((response)=>{
        this.rows = response.data;
      });
    }
  },

  mounted(){
    this.getDAta();
  }
}
</script>
